<template>
  <SubscriptionFeaturesContext>
    <router-view />
  </SubscriptionFeaturesContext>
</template>

<script lang="ts" setup>
import SubscriptionFeaturesContext from '@/components/deepadmin/subscription/SubscriptionFeaturesContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.settings.security.title',
  },
})
</script>
